import { fetchGroup, fetchWrapper } from '../api/gas';
export default async (logger) => {
    const [invites, groupData] = await Promise.all([
        fetchWrapper(() => fetchGroup('invite', {}, logger), []),
        fetchGroup('member', {}, logger),
    ]);
    const { members, quota, usage, maxMembers } = groupData;
    return { invites, members, quota, usage, maxMembers };
};
